import app from 'flarum/forum/app';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import icon from 'flarum/common/helpers/icon';

const setting = (key, isBool = false) => {
  const val = app.data[`fof-gamification.${key}`];

  if (isBool) {
    return !!Number(val);
  }

  return val;
};

const saveVote = (post, upvoted, downvoted, load, discussion = post.discussion()) => {
  if (!app.session.user) {
    // We use this instead of showing LogInModal so that extensions can override it
    DiscussionControls.replyAction.call(discussion, true);
    return;
  } else if (discussion && !discussion.canVote() && !post.canVote()) {
    return;
  }

  if (upvoted && downvoted) {
    upvoted = false;
    downvoted = false;
  }

  if (load) load(true);

  m.redraw();

  return post
    .save([upvoted, downvoted, 'vote'])
    .then(
      () => null,
      () => null
    )
    .then(() => {
      if (load) load(false);

      if (discussion) {
        discussion.pushAttributes({
          votes: post.votes(),
        });
      }

      m.redraw();
    });
};

const get = (discussion, key) => {
  const post = discussion.firstPost();

  if (post && post[key]() !== undefined) {
    return post[key]();
  }

  return discussion[key]();
};

export default function gamificationButtons(discussion) {
  if (!('fof-gamification' in flarum.extensions)) {
    return;
  }

  const post = discussion.firstPost();

  const hasUpvoted = get(discussion, 'hasUpvoted');
  const hasDownvoted = get(discussion, 'hasDownvoted');

  // We set canVote to true for guest users so that they can access the login by clicking the button
  const canVote = !app.session.user || get(discussion, 'canVote');

  const attrs = {
    disabled: !canVote,
  };

  return (
    <div className="DiscussionListItem-votes">
      {icon('fas fa-arrow-up', {
        'data-active': hasUpvoted,
        onclick: canVote && (() => saveVote(post, !hasUpvoted, false, null, discussion)),
        ...attrs,
      })}
      <span>{abbreviateNumber(get(discussion, 'votes') || 0)}</span>
      {icon('fas fa-arrow-down', {
        'data-active': hasDownvoted,
        onclick: canVote && (() => saveVote(post, false, !hasDownvoted, null, discussion)),
        ...attrs,
      })}
    </div>
  );
}
